<template>
  <Admin style="background: #f2f2f2">
    <v-main>

      <!-- Dialog to show raw text (e.g. extracted from either PDF or image) -->
     <v-dialog v-model="showTextDialog" max-width="800px">
        <v-card>
          <v-card-title class="headline">Extracted Text</v-card-title>
          <v-card-text style="max-height: 60vh; overflow: auto; white-space: pre-wrap;">
              <div class="tw-absolute tw-top-2 tw-right-2 tw-z-10 border-2 tw-p-5" >
                  <v-icon
                    v-if="rawText"
                    class="tw-cursor-pointer mr-5 mt-2"
                    style="font-size: 20px;"
                    small
                    @click="copyToClipboard(rawText)"
                    title="Copy extracted text to clipboard"
                  >
                  mdi-clipboard-outline
                </v-icon>
                <span
                  v-if="showCopiedMsg"
                  class="tw-absolute tw-top-2 tw-right-10 tw-mr-2 tw-text-green-600 tw-text-sm tw-font-medium tw-whitespace-nowrap tw-transition-opacity tw-duration-200 tw-p-5"
                >
                  ✓ Copied
                </span>
              </div>
            {{ rawText }}
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn class="tw-mt-5" text @click="showTextDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

         <v-dialog v-model="showResponse" max-width="800px">
        <v-card>
          <v-card-title class="headline">View Response</v-card-title>
          <v-card-text style="max-height: 60vh; overflow: auto; white-space: pre-wrap;">
                <div class="tw-absolute tw-top-2 tw-right-2 tw-z-10 border-2 tw-p-5" >
                 <v-icon
                    v-if=" rawText || jsonResult"
                    class="tw-cursor-pointer mr-5 mt-2"
                    style="font-size: 20px;"
                    small
                    @click="copyToClipboard(rawText + '\n\n' + formatJson(jsonResult))"
                    title="Copy raw text + JSON to clipboard"
                  >
                  mdi-clipboard-outline
                </v-icon>
                <span
                  v-if="showCopiedMsg"
                  class="tw-absolute tw-top-2 tw-right-10 tw-mr-2 tw-text-green-600 tw-text-sm tw-font-medium tw-whitespace-nowrap tw-transition-opacity tw-duration-200 tw-p-5"
                >
                  ✓ Copied
                </span>
              </div>
            {{ rawText}}
            {{jsonResult}}
            <br>
            process by : {{ service }}
            <br>
            Model by : {{ selectedModel.label }}
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn class="tw-mt-5" text @click="showResponse = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container>
        <v-card class="rounded-xl tw-min-h-80" v-if="!isProductListLoading">
          <v-card-text v-if="!selectedCompany.isDemo">
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>

            <!-- Main content -->
            <v-container fluid class="pa-0 fill-height">
              <v-row dense class="fill-height">
                <!-- Left side: Upload & Preview -->
                <v-col cols="12" md="5" class="d-flex flex-column">
                  <v-card outlined class="upload-card pa-2 d-flex flex-column flex-grow-1 tw-bg-light-gray">
                    <input
                      ref="fileInput"
                      type="file"
                      accept="application/pdf, image/*"
                      class="d-none"
                      @change="onFileSelected"
                    />
                    <div
                      v-if="!fileUrl"
                      class="upload-placeholder flex-grow-1 d-flex flex-column justify-center align-center"
                      @click="triggerFileSelect"
                    >
                      <v-icon size="64">mdi-cloud-upload</v-icon>
                      <p class="font-weight-bold">{{ fileName || 'Upload PDF or Image' }}</p>
                    </div>

                    <v-responsive v-else class="file-preview pdf-full">
                      <!-- If PDF, use iframe; if image, use img -->
                      <template v-if="isPdf">
                        <iframe
                          :src="fileUrl + '#toolbar=0&navpanes=0&scrollbar=0'"
                          frameborder="0"
                          class="w-100 h-100"
                        />
                      </template>
                      <template v-else>
                        <img :src="fileUrl" class="w-100 h-100" style="object-fit: contain;" />
                      </template>
                    </v-responsive>
                  </v-card>
                </v-col>

                <!-- Right side: Controls & Prompt -->
                <v-col cols="12" md="7">
                  <v-card outlined class="controls-card pa-6 d-flex flex-column">
                    <!-- Buttons row -->
                    <v-row dense no-gutters class="pa-2 tw-gap-2">
                      <v-col cols="auto" class="pa-0 ">
                        <v-btn
                          class="btn-short"
                          color="green"
                          :disabled="!fileUrl || !selectedModel || !prompt || isProcessing"
                          @click="processFile"
                        >
                          <template v-if="isProcessing">
                            <v-progress-circular indeterminate color="green" size="20" class="mr-2" />
                            Processing...
                          </template>
                          <template v-else> <v-icon class="tw-mr-1"  size="25">mdi-play</v-icon>Process</template>
                        </v-btn>
                      </v-col>
                      <v-col cols="auto"  class="pa-0  ">
                        <v-btn
                          class="btn-short"
                          color="red"
                          outlined
                          :disabled="!fileUrl || isProcessing"
                          @click="clearAll"
                        >
                      <v-icon class="tw-mr-1"  size="25">mdi-trash-can-outline</v-icon>Clear
                        </v-btn>
                      </v-col>
                      <v-col cols="auto"  class="pa-0  ">
                        <v-btn
                          class="btn-short"
                          color="blue"
                          outlined
                          :disabled="!rawText || isProcessing"
                          @click="showTextDialog = true"
                        >
                  <v-icon class="tw-mr-1"  size="25">mdi-format-text</v-icon> View Text
                        </v-btn>
                      </v-col>
                      <v-col cols="auto"  class="pa-0 ">
                        <v-btn
                          class="btn-short"
                          color="amber"
                          outlined
                          :disabled="!jsonResult || isProcessing"
                          @click="showResponse = true"
                        >
                        <v-icon class="tw-mr-1"  size="25">mdi-file-search-outline</v-icon>  View Response
                        </v-btn>
                      </v-col>
                    </v-row>

                    <!-- Model selection, service radio -->
                     <v-row dense no-gutters class="mt-4" align="center">
                      <v-col cols="auto" class="pa-1">
                        <v-radio-group v-model="selectedService" row>
                          <v-radio label="Google Vision" value="Google" />
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12" sm="6" class="pa-1 d-flex align-center">
                        <v-select
                          v-model="selectedModel"
                          :items="models"
                          return-object
                          label="Models"
                          outlined
                          dense
                          class="mt-5"
                        >
                        <template v-slot:item="{ item }">
                          <v-row align="center" no-gutters>
                            <v-avatar size="18" class="mr-2">
                              <img :src="`/images/${item.image}`" alt="">
                            </v-avatar>
                            <span class="tw-p-1">{{ item.label }}</span>
                          </v-row>
                        </template>

                        <template v-slot:selection="{ item }">
                          <v-row align="center" no-gutters>
                            <v-avatar size="18" class="mr-2">
                              <img :src="`/images/${item.image}`" alt="">
                            </v-avatar>
                            <span>{{ item.label }}</span>
                          </v-row>
                        </template>
                        </v-select>  
                      </v-col>
                    </v-row>
                    <!-- Prompt textarea -->
                    <v-textarea
                      v-model="prompt"
                      label="Prompt here..."
                      outlined
                      rows="20"
                      class="flex-grow-1 mt-4"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </v-container>

            <!-- JSON RESULT section -->
            <div class="tw-ml-9 tw-mt-10 tw-text-lg ">
            <div class="d-flex align-center justify-space-between">
            <p class="tw-font-bold">JSON RESULT :</p>
          </div>
            <div class="tw-relative tw-mr-8 tw-w-a4-landscape tw-h-a4-landscape tw-border-2 tw-rounded-md tw-bg-light-gray overflow-auto" style="max-height:100%;">
              <!-- FIXED Clipboard Icon -->
              <div class="tw-absolute tw-top-2 tw-right-2 tw-z-10 border-2" >
                <v-icon
                  v-if="jsonResult"
                  class="tw-cursor-pointer mr-5 mt-2"
                  style="font-size: 20px;"
                  small
                  @click="copyToClipboard(jsonResult)"
                  title="Copy JSON to clipboard"
                >
                  mdi-clipboard-outline
                </v-icon>
                <span
                  v-if="showCopiedMsg"
                  class="tw-absolute tw-top-2 tw-right-10 tw-mr-2 tw-text-green-600 tw-text-sm tw-font-medium tw-whitespace-nowrap tw-transition-opacity tw-duration-200"
                >
                  ✓ Copied
                </span>
              </div>
            <pre v-if="jsonResult" class="tw-whitespace-pre-wrap tw-overflow-auto tw-max-h-[500px] tw-p-2 tw-mt-10">
              {{jsonResult}}
              </pre>
              <p v-else class="tw-text-gray-500-500"></p>
            </div>
          </div>
          </v-card-text>

          <div v-else class="align-center justify-center" style="height: 200px; display: flex">
            No Permission
          </div>
        </v-card>

        <!-- Loading skeleton when product list is loading -->
        <v-card v-else class="rounded-xl tw-min-h-80 tw-p-7">
          <v-skeleton-loader type="list-item-two-line" style="width: 400px;" />
          <v-skeleton-loader type="list-item-three-line" style="width: 400px;" />
          <v-skeleton-loader type="list-item-three-line" style="width: 400px;" />
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import { mapState } from "vuex";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";

export default {
  name: "Board",
  components: { Admin },
  computed: {
    ...mapState({}),
  },

  data: () => ({
    items: [
      { text: "ตั้งค่า", disabled: false, to: { name: "Company.Settings" } },
      { text: "ทดสอบเอกสาร", disabled: true },
    ],
    models: [
      { label: 'Gemini Flash 2.5', value: 'gemini-2.5-flash',provider : 'Google',image :'gg.png' },
      { label: 'GPT-4.1 mini', value: 'gpt-4.1-mini',provider : 'OpenAI',image :'openai.png' },
      { label: 'o4-mini', value: 'o4-mini',provider : 'OpenAI',image :'openai.png' },
      { label: 'o3', value: 'o3',provider : 'OpenAI',image :'openai.png' },
      { label: 'GPT-4.1', value: 'gpt-4.1',provider : 'OpenAI',image :'openai.png' },
      // { label: 'GPT-4.1 Nano',  value: 'gpt-4.1-nano',provider : 'OpenAI',image :'openai.png' },
      { label: "GPT-4o", value: "gpt-4o",provider : 'OpenAI',image :'openai.png' },
      { label: "GPT-4o mini", value: "gpt-4o-mini",provider : 'OpenAI',image :'openai.png' },

    ],
    selectedModel: "gemini-2.5-flash",
    prompt: "",
    fileName: "",
    fileUrl: null,
    isPdf: false,            // NEW: track whether the selected file is a PDF
    selectedService: "Google",
    jsonResult: "",
    rawText: "",
    showTextDialog: false,
    showResponse: false,
    isProcessing: false,
    selectedCompany: "",
    service: "",
    isProductListLoading:false,
    showCopiedMsg: false,
  }),

  methods: {
    triggerFileSelect() {
      this.$refs.fileInput.click();
    },

    onFileSelected(e) {
      const file = e.target.files[0];
      if (!file) {
        this.fileName = "";
        this.fileUrl = null;
        this.isPdf = false;
        this.rawText = "";
        this.jsonResult = "";
        return;
      }

      this.fileName = file.name;
      this.fileUrl = URL.createObjectURL(file);
      this.isPdf = file.type === "application/pdf";
      this.rawText = "";
      this.jsonResult = "";
    },

    beforeDestroy() {
      if (this.fileUrl) URL.revokeObjectURL(this.fileUrl);
    },

    copyToClipboard(content) {
    try {
      navigator.clipboard.writeText(content);
      this.showCopiedMsg = true;
      // ซ่อนข้อความ ✓ Copied หลัง 5 วินาที
      setTimeout(() => {
        this.showCopiedMsg = false;
      }, 5000);
    } catch (err) {
      console.error("Copy failed:", err);
      alert("Copy failed");
    }
  },

    async processFile() {
      if (!this.fileUrl) return;

      this.jsonResult = "";
      this.rawText = "";
      this.service = "";
      this.isProcessing = true;

      try {
        const file = this.$refs.fileInput.files[0];
        const reader = new FileReader();

        reader.onload = async () => {
          try {
            // Convert to base64 string (strip off the prefix)
            const base64 = reader.result.split(",")[1];

            // If you want separate handling for images vs PDFs, you could do:
            // if (this.isPdf) { callTextPdfAP } else { callImageFunction }
            const callTextPdfAP = firebase
              .functions()
              .httpsCallable("callTextPdfAP");

            const { data } = await callTextPdfAP({
               pdfBuffer: base64,                   // เดิมคือ pdfBuffer
               prompt: this.prompt,
               model: this.selectedModel.value || 'gemini-2.5-flash',
               service: this.selectedService,
               provider: this.selectedModel.provider || 'Google',
               mimeType: file.type,                  // เช่น "application/pdf" หรือ "image/png"
            });

            this.jsonResult = data.jsonResult;
            this.rawText = data.rawText;
            this.service = data.service;
          } catch (err) {
            console.error("Error calling function:", err);
          } finally {
            this.isProcessing = false;
          }
        };

        reader.readAsDataURL(file);
      } catch (err) {
        console.error("Error reading file:", err);
        this.isProcessing = false;
      }
    },

    clearAll() {
      this.fileUrl = null;
      this.fileName = "";
      this.isPdf = false;
      this.selectedService = "Google";
      this.jsonResult = "";
      this.rawText = "";
    },

    formatJson(raw) {
      try {
        return JSON.stringify(JSON.parse(raw), null, 2);
      } catch (e) {
        return raw;
      }
    },
  },
};
</script>

<style lang="scss">
.row-detail {
  padding-left: 24px;
}
.auto-mail-time-box {
  display: inline-block;
  width: 100px;
  .v-text-field {
    fieldset {
      border-radius: 10px;
    }
    input[type="text"] {
      text-align: center;
    }
  }
  .v-text-field--outlined fieldset {
    top: 0;
    height: 50px;
  }
}
.upload-card {
  /* ให้ card ใช้ flex ทั้งแนวตั้งเต็มความสูงของ col */
  flex: 1 1 auto;
}

.pdf-full {
  /* container ของ iframe เก็บ flex-grow */
  flex: 1 1 auto;
  position: relative;
}

.pdf-full iframe {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  border: none;
}

</style>